import { Popover, Tooltip } from "antd";
import React, { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { ICONS } from "../../../../../assets/icons";
import { ICONSS } from "../../../../../assets/icons/index1";
import ListViewSearch from "../../../../../components/commonComponents/ListViewHeader/ListViewSearch";
import LineLoader from "../../commonComponents/loader/LineLoader";
import CrmTable from "./CrmTable";
import NoCrm from "./NoCrm";

const MainContactList = ({
  crmLists,
  isLoading,
  visibleColumns,
  loadNextPage,
  count,
  count1,
  isFilter,
  no,
  viewListsShow,
  viewLists,
  handleCountry,
  countryListss,
  countryTrue,
  handleCountryChange,
  handleDelete,
  handleUpdate,
  handleProvince,
  handleProvinceChange,
  stateList,
  provinceTrue,
  handleEmail,
  emailTrue,
  handleEmailChange,
  cityTrue,
  handleCityChange,
  cityList,
  handleCity,
  viewCount,
  selectedItems,
  handleSelect,
  handleSelectAll,
  selectAll,
  totalSelectedCount,
  handleRemoveTag,
  handleAddTag
}) => {
  const [isTagsDropdownOpen, setIsTagsDropdownOpen] = useState(null);
  const firstColumnRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const { crmColumn } = useSelector((store) => store.crm);

  // to hide popover on scroll
  useEffect(() => {
    const handleScroll = (e) => {
      {
        isTagsDropdownOpen && setIsTagsDropdownOpen(null);
        const { scrollLeft, scrollWidth, clientWidth } = e.target;
        // const indication = Math.ceil(
        //   (scrollTop / (scrollHeight - clientHeight)) * 100,
        // );

        // indication > 50 &&
        //   columns.length <= 70 &&
        //   FetchColumns());
        const position = Math.ceil(
          (scrollLeft / (scrollWidth - clientWidth)) * 100
        );
        const containers = firstColumnRef?.current?.children;

        position === 0 && handleScrollShadow("remove", containers);
        position > 0 && position <= 4 && handleScrollShadow("add", containers);
      }
    };
    // to show and hide single column scroll shadow
    function handleScrollShadow(
      method = "add",
      collection,
      classList = "scroll-shadow"
    ) {
      for (let i = 0; i < collection?.length; i++) {
        collection?.[i]?.children?.[0]?.classList?.[method]?.(classList);
      }
    }

    const refElement = scrollContainerRef.current;

    // refElement.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    // return () => {
    //   refElement.removeEventListener("scroll", handleScroll);
    // };
  }, [isTagsDropdownOpen]);

  // const fetchColumns = async () => {
  //   setIsColumnsLoading(true);
  //   try {
  //     await setTimeout(() => {
  //       setColumns((prev) => [...prev, ...crmLists]);
  //       setIsColumnsLoading(false);
  //     }, 500);
  //   } catch (error) {
  //   } finally {
  //   }
  // };

  const [searchText, setSearchText] = useState("");

  const filteredStateList = stateList?.filter((data) =>
    data.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const filteredCityList = cityList?.filter((data) =>
    data.name.toLowerCase().includes(searchText.toLowerCase())
  );
  return (
    <div className="overflow-scroll sm:w-[99.4%] 2xl:w-full relative">
      {/* <LineLoader visible={isColumnsLoading} /> */}
      {isLoading && (
        <div className="w-full h-[2vh] flex items-center justify-center ">
          <LineLoader
            visible={isLoading}
            Width="200vw"
            loaderBg="4px solid white"
            loaderColor="4px solid var(--new-primary)"
            primaryColor="var(--new-primary)"
          />
        </div>
      )}
      {!viewListsShow && (
        <div
          className="container"
          style={{
            height: "79vh",
          }}
        >
          <div
            className="innerContainer listScroll pr-[0.5vw] pl-10"
            id="scrollableDiv"
          >
            {/* <Skeleton loading={isLoading} active paragraph={{ rows: 7 }}> */}
            <InfiniteScroll
              dataLength={crmLists?.length}
              next={loadNextPage}
              hasMore={crmLists?.length < count}
              scrollableTarget="scrollableDiv"
            >
              {crmLists?.length > 0 ? (
                <table className="">
                  <thead className="!text-[var(--textBlack)] bg-[#FAFAFA]">
                    <tr>
                      <th className="">
                        <div className="px-3">
                          <input
                            type="checkbox"
                            name="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                            className="accent-[var(--new-primary)]"
                          />
                        </div>
                      </th>
                      {crmColumn
                        ?.filter((column) => visibleColumns?.includes(column?.label))
                        ?.map((item, i) => (
                          <th
                            key={i}
                            className={`min-w-[15vw] ptb-10 ${item?.label === "Name" ? "text-left px-1" : "text-center"}`}
                            style={{ fontSize: "0.95vw", fontWeight: "500" }}
                          >
                            {item?.label}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {crmLists?.map((item, i) => {
                      const isSelected = selectedItems?.find(
                        (si) => si.id === item.id
                      )?.selected;
                      return (
                        <CrmTable
                          key={`${item?.name}-${i}`}
                          isLoading={isLoading}
                          data={item}
                          visibleColumns={visibleColumns}
                          isFilter={isFilter}
                          selected={isSelected}
                          onSelect={() => handleSelect(item.id)}
                          handleRemoveTag={handleRemoveTag}
                          handleAddTag={handleAddTag}
                        />
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <div className="h-[40vh]">
                  <NoCrm no={no} />
                </div>
              )}
            </InfiniteScroll>
            {/* </Skeleton> */}
          </div>
        </div>
      )}

      {viewListsShow && (
        <div className="w-full flex flex-col">
          {viewLists?.length > 0 && (
            <div className="flex-row w-100 bg-white py-2 px-4 font14px-500 text-[var(--font-600)]">
              <span className="w-[18%]">Name</span>
              <span className="w-[19%]">Mobile Number</span>
              <span className="w-[19%]">Email ID</span>
              <span className="w-[18%]">Country</span>
              <span className="w-[18%]">State</span>
              <span className="w-[18%]">City</span>
              <span className="w-[20%]">First Name</span>
              <span className="w-10">Last Name</span>
            </div>
          )}

          <div
            className="innerContainer listScroll h-[80vh] overflow-scroll"
            id="scrollableDiv"
          >
            {/* <Skeleton loading={isLoading} active paragraph={{ rows: 7 }}> */}
            <InfiniteScroll
              dataLength={viewLists?.length}
              next={loadNextPage}
              hasMore={viewLists?.length < viewCount}
              scrollableTarget="scrollableDiv"
            >
              {viewLists?.length > 0 ? (
                <div className="mt-2 w-100">
                  {viewLists?.map((l, index) => {
                    const contactInfo = l?.contact_person_info || {};
                    const errorNotes = l?.error_notes || [];
                    const errors = l?.settings || {};

                    const getErrorMessage = (key) => {
                      const error = errorNotes.find(
                        (err) => err.column === key
                      );
                      return error ? error.message : null;
                    };

                    return (
                      <div
                        key={l?.id || index}
                        className="flex-row align-center w-100 space-between py-4 px-4 odd:bg-gray-100 even:bg-white font14px-400 text-[var(--textBlack)] capitalize"
                      >
                        <div className="w-[18%] flex-column">
                          <span>
                            {l?.first_name || "--"} {l?.last_name || "--"}
                          </span>
                          <span className="italic font12px-400 text-[var(--borderRed)]">
                            {errors?.remaining_errors} / {errors?.total_errors}{" "}
                            Errors
                          </span>
                        </div>

                        <div className="w-[19%]">
                          {contactInfo["country-code"]
                            ? `(+${contactInfo["country-code"]}) ${contactInfo["mobile-number"]}`
                            : "No Mobile"}
                        </div>

                        {!emailTrue[l?.id] ? (
                          <div
                            className="w-[20%] flex-row align-center gap-2 pointer"
                            onClick={() => {
                              if (getErrorMessage("email-id"))
                                handleEmail(l?.id);
                            }}
                          >
                            {getErrorMessage("email-id") && (
                              <Tooltip title={`${getErrorMessage("email-id")}`}>
                                <img src={ICONS?.alertIconError} alt="" />
                              </Tooltip>
                            )}
                            {contactInfo["email-id"]?.length > 17 ? (
                              <Tooltip title={contactInfo["email-id"]}>
                                <div className="flex-row align-center truncate overflow-hidden whitespace-nowrap">
                                  <span
                                    className={`max-w-[15ch] inline-block text-[0.85vw] overflow-hidden text-ellipsis ${
                                      getErrorMessage("email-id")
                                        ? "text-[var(--borderRed)]"
                                        : ""
                                    }`}
                                  >
                                    {contactInfo["email-id"] || "--"}
                                  </span>
                                </div>
                              </Tooltip>
                            ) : (
                              <div className={`max-w-[15ch] inline-block text-[0.85vw] overflow-hidden text-ellipsis ${
                                getErrorMessage("email-id")
                                  ? "text-[var(--borderRed)]"
                                    : ""}`}
                              >
                                {contactInfo["email-id"] || "--"}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="w-[20%] flex-row align-center gap-2 pointer">
                            <input
                              type="text"
                              className="bg-none border border-[var(--border-input)] rounded-[4px]"
                              value={contactInfo["email-id"] || ""}
                              onChange={(e) =>
                                handleEmailChange(l?.id, e.target.value)
                              }
                            />
                            <img
                              src={ICONSS?.crmDelete}
                              alt="crmDelete"
                              onClick={() => handleDelete(l?.id)}
                            />
                            <img
                              src={ICONSS?.crmUpdate}
                              alt="crmUpdate"
                              onClick={() => handleUpdate(l, l?.id)}
                            />
                          </div>
                        )}

                        {!countryTrue[l.id] ? (
                          <div
                            className="w-[19%] flex-row align-center gap-2 pointer"
                            onClick={() => {
                              if (getErrorMessage("country")) {
                                handleCountry(l.id);
                              }
                            }}
                          >
                            {getErrorMessage("country") && (
                              <Tooltip title={`${getErrorMessage("country")}`}>
                                <img src={ICONS?.alertIconError} alt="" />
                              </Tooltip>
                            )}
                            <span
                              className={`${
                                getErrorMessage("country")
                                  ? "text-[var(--borderRed)]"
                                  : ""
                              }`}
                            >
                              {contactInfo["country"] || "--"}
                            </span>
                          </div>
                        ) : (
                          <div className="w-[19%] flex-row align-center gap-2 pointer">
                            <Popover
                              arrow={false}
                              content={
                                <div className="country-popover flex-column w-100 p-10">
                                  {countryListss?.map((data) => (
                                    <div
                                      className="flex-column pointer p-10 max-h-[10vh]"
                                      key={data?.id}
                                      onClick={() =>
                                        handleCountryChange(l.id, data)
                                      }
                                    >
                                      <div className="flex-row align-center justify-between">
                                        <span className="">{data?.name}</span>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              }
                              trigger="click"
                            >
                              <button className="border rounded-[4px]  p-5">
                                {contactInfo["country"]
                                  ? contactInfo["country"]
                                  : "Select Country"}
                              </button>
                            </Popover>
                            <img
                              src={ICONSS?.crmDelete}
                              alt="crmDelete"
                              onClick={() => handleDelete(l?.id)}
                            />
                            <img
                              src={ICONSS?.crmUpdate}
                              alt="crmUpdate"
                              onClick={() => handleUpdate(l, l?.id)}
                            />
                          </div>
                        )}

                        {!provinceTrue[l.id] ? (
                          <div
                            className="w-[19%] flex-row align-center gap-2 pointer"
                            onClick={() => {
                              if (
                                getErrorMessage("province") ||
                                getErrorMessage("city")
                              ) {
                                handleProvince(l.id);
                              }
                            }}
                          >
                            {getErrorMessage("province") && (
                              <Tooltip title={`${getErrorMessage("province")}`}>
                                <img src={ICONS?.alertIconError} alt="" />
                              </Tooltip>
                            )}
                            <span
                              className={`${
                                getErrorMessage("province")
                                  ? "text-[var(--borderRed)] mt-"
                                  : ""
                              }`}
                            >
                              {contactInfo["province"] || "--"}
                            </span>
                          </div>
                        ) : (
                          <div className="w-[19%] flex-row align-center gap-2 pointer">
                            <Popover
                              arrow={false}
                              content={
                                <div className="country-popover flex-column w-100 p-10">
                                  <ListViewSearch
                                    searchingText={(text) =>
                                      setSearchText(text)
                                    }
                                  />

                                  {filteredStateList?.map((data) => (
                                    <div
                                      className="flex-column pointer p-10 max-h-[10vh]"
                                      key={data?.id}
                                      onClick={() =>
                                        handleProvinceChange(l.id, data)
                                      }
                                    >
                                      <div className="flex-row align-center justify-between">
                                        <span className="">{data?.name}</span>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              }
                              trigger="click"
                            >
                              <button className="border rounded-[4px] p-5">
                                {contactInfo["province"]
                                  ? contactInfo["province"]
                                  : "Select Province"}
                              </button>
                            </Popover>

                            <img
                              src={ICONSS?.crmDelete}
                              alt="crmDelete"
                              onClick={() => handleDelete(l?.id)}
                            />
                            <img
                              src={ICONSS?.crmUpdate}
                              alt="crmUpdate"
                              onClick={() => handleUpdate(l, l?.id)}
                            />
                          </div>
                        )}

                        {!cityTrue[l?.id] ? (
                          <div
                            className="w-[19%] flex-row align-center gap-2 pointer"
                            onClick={() => {
                              if (getErrorMessage("city")) {
                                handleCity(l?.id, l);
                              }
                            }}
                          >
                            {getErrorMessage("city") && (
                              <Tooltip title={`${getErrorMessage("city")}`}>
                                <img src={ICONS?.alertIconError} alt="" />
                              </Tooltip>
                            )}
                            <span
                              className={`${
                                getErrorMessage("city")
                                  ? "text-[var(--borderRed)]"
                                  : ""
                              }`}
                            >
                              {contactInfo["city"] || "--"}
                            </span>
                          </div>
                        ) : (
                          <div className="w-[19%] flex-row align-center gap-2 pointer z-50">
                            <Popover
                              arrow={false}
                              content={
                                <div className="country-popover flex-column w-100 p-10">
                                  <ListViewSearch
                                    searchingText={(text) =>
                                      setSearchText(text)
                                    }
                                  />

                                  {filteredCityList?.map((data) => (
                                    <div
                                      className="flex-column pointer p-10 max-h-[10vh]"
                                      key={data?.id}
                                      onClick={() =>
                                        handleCityChange(l.id, data)
                                      }
                                    >
                                      <div className="flex-row align-center justify-between">
                                        <span className="">{data?.name}</span>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              }
                              trigger="click"
                            >
                              <button className="border rounded-[4px]  p-5">
                                {contactInfo["city"]
                                  ? contactInfo["city"]
                                  : "Select city"}
                              </button>
                            </Popover>
                            <img
                              src={ICONSS?.crmDelete}
                              alt="crmDelete"
                              onClick={() => handleDelete(l?.id)}
                            />
                            <img
                              src={ICONSS?.crmUpdate}
                              alt="crmUpdate"
                              onClick={() => handleUpdate(l, l?.id)}
                            />
                          </div>
                        )}

                        <span className="w-[20%]">{l?.first_name || "--"}</span>

                        <span className="w-[9%]">{l?.last_name || "--"}</span>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="h-[40vh]">
                  <NoCrm no={no} viewListsShow={viewListsShow} />
                </div>
              )}
            </InfiniteScroll>
          </div>

          {/* Data Rows */}
        </div>
      )}
    </div>
  );
};

export default MainContactList;
